import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PdfViewerModule } from 'ng2-pdf-viewer';
//import { SearchPipe } from './clinical-communications/searchFilter.pipe';
import { PieChartModule } from '@swimlane/ngx-charts';
import { NgxPaginationModule } from 'ngx-pagination';
// import { NgProgressModule } from 'ngx-progressbar';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabsModule  } from 'primeng/tabs';
import { AuthMessagesModule } from '../messagesmodule/authmessages.module';
import { SharedModules } from '../shared/shared.module';
import { ProviderDashboardComponent } from './../providerportal/providerdashboard/providerdashboard.component';
import { ClaimsummaryComponent } from './claimsummary/claimsummary.component';
import { ClaimsummarydetailComponent } from './claimsummarydetail/claimsummarydetail.component';
import { DisputeDialogComponent } from './claimsummary/dispute-dialog/dispute-dialog.component';
import { ClinicalCommunicationsComponent } from './clinical-communications/clinical-communications.component';
import { DateFormatPipe } from './clinical-communications/durationFilter.pipe';
import { EligibilityReportComponent } from './eligibility-report/eligibility-report.component';
import { EpahafComponent } from './epahaf/epahaf.component';
import { PahafChartComponent } from './epahaf/pahaf-chart/pahaf-chart.component';
import { PahafFormComponent } from './epahaf/pahaf-form/pahaf-form.component';
import { PcpScorecardComponent } from './pcp-scorecard/pcp-scorecard.component';
import { ProviderDataUpdateComponent } from './provider-data-update/provider-data-update.component';
import { ProviderportalComponent } from './provider-portal/providerportal.component';
import { ProviderTrainingComponent } from './provider-training/provider-training.component';
import { ProviderRouteDefinitions } from './provider.route';
import { ProviderComponent } from './provider_component/provider.component';
import { ProviderDetailsComponent } from './providerdetails_component/providerdetails.component';
import { ProviderSearchComponent } from './providersearch_component/providersearch.component';
import { ProviderSearchPanelComponent } from './providersearchpanel_component/providersearchpanel.component';
import { StarRatingComponent } from './starrating_component/starrating.component';

import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { NgxLoadingModule } from 'ngx-loading';
import { CarePlanDocumentComponent } from '../care-plan-document/care-plan-document.component';
import { PatientSurveyResultComponent } from './patient-survey-result/patient-survey-result.component';
import { SortDirectiveNew } from '../shared/directive/sort.directivenew';
import { ProviderOutreachComponent } from './provider-outreach/provider-outreach.component';
import { PqvDashboardComponent } from './pqvdashboard/pqvdashboard.component';
import { PatientDashboardComponent } from './pqvdashboard/patientdashboard/patientdashboard.component';
import { MedicationDetailsComponent } from './pqvdashboard/medicationDetails/medicationDetails.component';
import { LabDetailsComponent } from './pqvdashboard/labDetails/labDetails.component';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { ClinicalVisitComponent } from './pqvdashboard/clinical-visit/clinical-visit.component';
import { PahafBulkDownloadComponent } from './epahaf/pahaf-bulk-download/pahaf-bulk-download.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModules,
    ProviderRouteDefinitions,
    AutoCompleteModule,
    AccordionModule,
    AuthMessagesModule,
    NgxLoadingModule,
    TabsModule,
    NgxPaginationModule,
    SelectModule,
    PieChartModule,
    MultiSelectModule,
    PdfViewerModule,
    AngularMultiSelectModule,
    DatePickerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
  declarations: [
    ProviderSearchComponent,
    ProviderComponent,
    ProviderSearchPanelComponent,
    ProviderDetailsComponent,
    ProviderDashboardComponent,
    ProviderportalComponent,
    StarRatingComponent,
    ClinicalCommunicationsComponent,
    DateFormatPipe,
    ClaimsummaryComponent,
    ClaimsummarydetailComponent,
    DisputeDialogComponent,
    EpahafComponent,
    PahafFormComponent,
    EligibilityReportComponent,
    PahafChartComponent,
    PcpScorecardComponent,
    ProviderTrainingComponent,
    CarePlanDocumentComponent,
    PatientSurveyResultComponent,
    ProviderDataUpdateComponent,
    ProviderOutreachComponent,
    PqvDashboardComponent,
    PatientDashboardComponent,
    MedicationDetailsComponent,
    LabDetailsComponent,
    ClinicalVisitComponent,
    PahafBulkDownloadComponent
  ],
  exports: [
    ProviderSearchComponent,
    ProviderSearchPanelComponent,
    ProviderDetailsComponent,
    DateFormatPipe,
  ],
})
export class ProviderModule {}
